import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from 'services/Auth';

class ExtraSalesApi extends Api {
  constructor() {
    super('promo/extrasales/');
  }

  getExcel(params) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/extrasales.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }

  handleApproveOrReject(id, data) {
    this.buildQuery('post', data, `${id}/approve`);
  }

  memberApprove(id, data) {
    return this.buildQuery(
      'post',
      {
        data,
      },
      `${id}/member`,
    );
  }

  checkMemberByCompany(id, company_id, extrasale_hour_id) {
    return this.buildQuery(
      'get',
      {
        params: {
          company_id,
          extrasale_hour_id,
        },
      },
      `${id}/member_by_company`,
    );
  }

  createEvent(data) {
    return this.buildQuery(
      'post',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      '',
    );
  }

  updateEvent(id, data) {
    return this.buildQuery(
      'put',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      id,
    );
  }

  deleteFile(id, fileId) {
    return this.buildQuery(
      'delete',
      {
        data: {
          ids: fileId,
        },
      },
      `${id}/remove_attachments`,
    );
  }
}

export default ExtraSalesApi;
